import Logo from "@/components/logo";

import SettingButton from "./setting-button";
import AccountDropdown from "../components/account-dropdown";

export default function HeaderSimple() {
	return (
		<header className="flex h-16 w-full items-center justify-between px-6">
			<Logo size={30} />
			<div className="flex gap-2">
				<SettingButton />
				<AccountDropdown />
			</div>
		</header>
	);
}
